import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=379b880c&scoped=true"
import script from "./tagInput.vue?vue&type=script&lang=js"
export * from "./tagInput.vue?vue&type=script&lang=js"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=379b880c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b880c",
  null
  
)

export default component.exports